module.exports = __webpack_public_path__ + "img/k1.138ecb67.png";